import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  PLATFORM_ID,
  ViewChild
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  Router
} from '@angular/router';
import {
  DataServiceService
} from 'src/app/services/data-service.service';
import {
  SeoService
} from 'src/app/services/seo.service';
import {
  Meta
} from '@angular/platform-browser';
import {
  environment
} from '../../../environments/environment';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-open-account',
    templateUrl: './open-account.component.html',
    styleUrls: ['./open-account.component.scss'],
    providers: [DataServiceService],
    imports: [CommonModule,ReactiveFormsModule,FormsModule]    
})
export class OpenAccountComponent implements OnInit {

  title = "Contact or Open An Account with Investing for Catholics";

  name = "";
  email = "";
  phone = "";
  message = "";
  isNameValid = null;
  isEmailValid = null;
  isSending = false;
  contactFormMessage = "";

  @ViewChild('captchaRef2',{static:false}) captchaRef2: ElementRef;
  private _reCaptchaId: number;
  reCaptchaVerified = false;

  constructor(
    public hc: HttpClient,
    public router: Router,
    private seoservice: SeoService,
    private meta: Meta,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  contactFormSubmit() {

    if (this.isNameValid && this.isEmailValid && this.reCaptchaVerified) {

      this.isSending = true;

      // var dta = {
      //   to: this.email,
      //   from: "mary@ifa.com",
      //   subject: "Thank You For Contacting Investing for Catholics",
      //   template_id: "d-1414c6e0b4eb4beca84edf927f53d14f"
      // };

      // this.sendEmail(dta);

      var contactSubmission = {
        to: "mary@ifa.com",
        to_name: "Mary Brunson",
        from: "noreply@ifa.com",
        from_name: this.name,
        reply_to: this.email,
        reply_to_name: this.name,
        subject: "IFC Contact Request",
        dynamic_template_data: {
          "message": this.message,
          "name": this.name,
          "email": this.email,
          "phone": this.phone,
          "subject": "IFC Contact Request"
        },
        template_id: "d-6f817a545b714d7f8e9ce8fed9ab283a"
      };

      this.sendEmail(contactSubmission);

    } else {
      alert("Please complete the form");

    }

  }

  // error messages of input fields
  errorMessages = {
    name: 'Name must be at least 3 characters.',
    email: 'Email is invalid.',
    //phone: 'Phone must be at least 10 characters.',
    //message: 'Message must be at least 10 characters.',
  };


  sendEmail(dta) {

    var promise = this.hc.post("https://data2.ifa.com/api/v1/email/", dta)
    promise.subscribe((resp: any) => {
      if (resp.IsSuccessStatusCode) {
        this.contactFormMessage = "Your message was sent successfully";
      } else {
        this.contactFormMessage = "An error occured while sending your message, please try again.";
      }
    }, error => {
      this.contactFormMessage = error
    })
  }


  nameValidationText = "";
  emailValidationText = "";

  validateName() {
    this.isNameValid = (this.name.length >= 2);
    if (this.isNameValid) {
      this.nameValidationText = "";
    } else {
      this.nameValidationText = (this.errorMessages.name);
    }
  }

  validateEmail() {
    var emailRegEx = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.isEmailValid = emailRegEx.test(this.email);
    if (this.isEmailValid) {
      this.emailValidationText = "";
    } else {
      this.emailValidationText = (this.errorMessages.email);
    }
  }

  CryptMailto(e, name) {
    var n = 0;
    var r = "";
    var s = "mailto:" + e;

    e = e.replace(/@/, " [at] ");
    e = e.replace(/\./g, " [dot] ");

    for (var i = 0; i < s.length; i++) {
      n = s.charCodeAt(i);
      if (n >= 8364) {
        n = 128;
      }
      r += String.fromCharCode(n + 1);
    }
    //  document.forms[0].cyptedEmailField.value = r;

    document.write("<a href=\"javascript:linkTo_UnCryptMailto('" + r + "');\">" + name + "</a>");
  }

  UnCryptMailto(s) {
    var n = 0;
    var r = "";
    for (var i = 0; i < s.length; i++) {
      n = s.charCodeAt(i);
      if (n >= 8364) {
        n = 128;
      }
      r += String.fromCharCode(n - 1);
    }
    return r;
  }

  linkTo_UnCryptMailto(s) {
    location.href = this.UnCryptMailto(s);
  }


  ngOnInit() {

    this.seoservice.updateTitle(this.title);
    this.meta.addTag({
      name: 'keywords',
      content: 'Investing for Catholics, Investing, Contact Investing for Catholics, Open Investment Account'
    });
    this.meta.addTag({
      name: 'description',
      content: 'Contact Investing for Catholics (IFC) or open an account for all your investing needs.'
    });
    this.meta.addTag({
      name: 'author',
      content: 'Investing for Catholics (IFC)'
    });
    this.meta.addTag({
      name: 'robots',
      content: 'index, follow'
    });
  }


  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      const grecaptcha = (window as any).grecaptcha;
      if (grecaptcha) {

        let timer = 0;

        if(!grecaptcha.render){
          timer=2000;
        }
        setTimeout(()=>{
          this._reCaptchaId = grecaptcha.render(this.captchaRef2.nativeElement, {
                  'sitekey': environment.googleReCaptchaKey,
                  'callback': (resonse) => this.reCapchaSuccess(resonse),
                  'expired-callback': () => this.reCapchaExpired()
                });
        },timer);

        
      }
    }
  }
  reCapchaSuccess(data: any) {
    if (data) {
// $&("Congratulation! reCAPTCHA verified.", data)
      // Some logic goes here
      this.reCaptchaVerified = true;
    }
  }
  reCapchaExpired() {
    alert("Oops! reCAPTCHA expired.")
    // Some logic goes here
    this.reCaptchaVerified = false;
  }

}